import React,{useState,useEffect} from "react";
import AddPreviousEmpDetails from "./AddPreviousEmpDetails";
import AddQualificationModel from "./AddQualificationModel";
import { getNewCondidateQualificationList } from "../../../Redux/Actions/newJoinerAction";
import { useDispatch,useSelector } from "react-redux";
import {httpDeleteQualificationDetails} from '../../HR/onboarding/api/Calls'

const AddQualificationDetail = ({tab,userID,setTab}) => {
    const dispatch = useDispatch()
    const {qualicationList} = useSelector((state) => state.NewJoinerReducer);

    const [previous,setPrevious] = useState('');
    const [selected,setSelected] = useState('')
    const [downloadURL, setDownloadURL] = useState("");
    let SERVER_URL = process.env.REACT_APP_API_URL;


    const download = async (id) => {
        
    
        const result = await fetch(SERVER_URL+`api/condidate/download/document/${id}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"},
        });
        const blob = await result.blob();
        const url = URL.createObjectURL(blob);
        setDownloadURL(url);
      };
      const handleDownload = async (id) => {
        try {
          await download(id);
          // Call this method when you've finished using an object URL to let the browser know not to keep the reference to the file any longer.
          URL.revokeObjectURL(downloadURL);
        } catch (error) {
          console.error(error);
        }
      };

    useEffect(()=>{
        dispatch(getNewCondidateQualificationList(userID))
    },[userID])
    const nextEmployeement = () =>{
        setTab(4);
        setSelected(null);
    }
    const previousEmployeement = () =>{
        setPrevious(2);
        setTab(2);
        setSelected(null);
    }
    const updateHandler = (item) =>{
        setSelected(item)
    }
 
    
    const deleteHandler = async (id) =>{
        //setSelected(1)
        await httpDeleteQualificationDetails(id).then((res) => {
            if (res.status) {
                dispatch(getNewCondidateQualificationList(userID))
                return alert(res.msg);
            } else {
                return alert(res.msg);
            }
        });
    }
    const handleOpenPopup = () => {
        setSelected(null);
    };
    return (
        <>
        <AddQualificationModel edit={selected} userID={userID} setSelected={setSelected} />
            <div className={`tab-pane fade ${tab === 3 ?'active show':''}`} id="qualificationdetail" role="tabpanel" aria-labelledby="qualification-tab">
                <div className="tab_content">
                    <button className="btn_5 float-end mb15" data-bs-toggle="modal" data-bs-target="#educationdetail" onClick={handleOpenPopup}>Add Qualification Detail</button>
                    <div className="dash_white_box_ttl mb25">QUALIFICATION DETAIL</div>
                    <table className="monthly_table mt20 mb25">
                        <thead>
                            <tr rowSpan={2}>
                                <th>Educational Institutions Name</th>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th>Degree / Diploma Major Subjects </th>
                                <th>Major Subjects</th>
                                <th className="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {qualicationList?.length > 0 ?
                            qualicationList?.map((item, keys) => {
                                return (
                            <tr key={keys}>
                                <td>{item.name}</td>
                                <td>{item.from_year}</td>
                                <td>{item.to_year}</td>
                                <td>{item.degree_name}</td>
                                <td>{item.subject}</td>
                                <td className="text-right">
                               
                                    <button onClick={()=>handleDownload(item.id)} className="btn_9 mr05"> <a target="_blank" href={`${SERVER_URL + "doc/" + item.document}`}  download={`${SERVER_URL + "doc/" + item.document}`}><i className="icon icon-download" /></a></button>
                                    <button className="btn_7 mr05" data-bs-toggle="modal" data-bs-target="#educationdetail" onClick={() => updateHandler(item)} ><i className="icon icon-pencil"   /></button>
                                    <button className="btn_8"><i className="icon icon-cross" onClick={() =>deleteHandler(item.id)} /></button>
                                </td>
                            </tr>
                            )})
                            : 
                            <tr>
                                <td colSpan={6} className="text-center">
                                    <div className="notfound">No Record found</div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div className="tab_footer text-end">
                    <button className="btn_5 float-start" onClick={previousEmployeement}>Previous</button>
                    <button className="btn_5" onClick={nextEmployeement}>Save & Next</button>
                </div>
            </div>
            
            <AddPreviousEmpDetails tab={tab} userID={userID} setTab={setTab}/>
        </>
    )
}
export default AddQualificationDetail;